module.exports = __webpack_public_path__ + "313eadc0ae0371d75e34422371ef3067.pdf";